<template>

    <div :class="activeted ? 'selectListStyle' : 'selectStyle'">
        <input v-bind="$attrs"
               v-on="$listeners" v-model="labelData" @focus="handleFocus" @blur="handleBlur" class="input-style" />
       
        <div class="select-div"   v-if="activeted">
                <li class="input_li"  v-for="(item,index) in selectList" :key="index"  @mousedown="handleClick(item)">{{item.label.length>14 ? item.label.slice(0,16) + ' ...' : item.label  }}</li>
        </div>
    </div>

</template>

<script>
    import {getSelectUrl} from '@/api/dominant_term/index.js'
import { Loading } from 'vant'
    export default {
        name: "ct-input",
        components:{},
        data(){
            return {
                selectAllList: [],   //下拉选列表
                labelData: '',   //展示的内容
                activeted: false,
                allSelectData: {},  //所有数据
                selectList: []
            }
        },
        props: {
            propType: String,   //字段key  ,即vmodel
            title: Array,   //根据此数组遍历所有url发送请求
            preData: Object,   //对象，里面的key-value 通过propType进行赋值
            initValue: ''   //初始code
        },
         watch: {
            labelData(n){
                if(!n) {
                    this.selectList = [...this.selectAllList]
                }
                else{
                    const len = n.length
                    if (this.selectAllList.length > 0) {
                        this.selectList = this.selectAllList.filter(l => {
                            if(l.label.length < len) return false
                            // if(l.label.substring(0,len) == n) return true
                            // return false
                            return l.label.toLowerCase().indexOf(n.toLowerCase()) != -1
                        })
                    }
                    else {
                        this.selectList = [
                            {
                                label: '没有正确加载数据',
                                value: 0
                            }

                        ]
                    }
                }
            },
             title: {
                 deep: true,
                 handler(n,o){
                     if (o.length != 0){
                         this.waitTitle()
                     }
                 }
             },
             initValue:{
                deep:true,
                immediate:true,
                handler(n,o){                            
                    if(n && isNaN(n)){
                        this.labelData = n
                        // this.changeDataClick(n)
                    }
                }
             }
        },
        methods: {
            changeDataClick(n){
                if(!n) {
                    this.selectList = []
                }
                else{
                    const len = n.length
                    const data = []
                    if (this.selectAllList.length > 0) {
                        data = this.selectAllList.filter(l => {
                            if(l.label.length < len) return false
                            if(l.label.substring(0,len) == n) return true
                            return false
                        })
                        if(data.length > 0){
                            this.label = n
                        }
                    }
                    else {
                        this.selectList = [
                            {
                                label: '没有正确加载数据',
                                value: 0
                            }

                        ]
                    }
                }
            },
            handleFocus(){
                this.activeted = true
            },
            handleBlur(){
                this.activeted = false
            },
            handleClick(data){
                console.log(data);
                this.labelData = data.label
                this.$emit("selectData",data.value)
                this.activeted = false

                // this.preData[this.propType] = data.value
            },
            /*
            * 循环调用url
            * */
            urlList(i){
                return new Promise(resolve => {
                    getSelectUrl({
                        url: i.url
                    }).then(suc => {
                        console.log(suc);
                        this.allSelectData[i.vmodel] = suc.data.data
                        resolve(true)
                    })
                })
            },
            /*
            * 加载title
            * */
            loadTitle(){
                return new Promise(async resolve => {
                    for(var i = 0;i < this.title.length;i++){
                        if(this.title[i].url){
                            await this.urlList(this.title[i])
                        }
                    }
                    resolve(true)
                })

            },
            /*
            * 业务处理 ,等待title传来之后在进行处理
            * */
            waitTitle(){
                if(!this.title){
                    setTimeout(() => {
                        this.waitTitle()
                    },50)
                }else{
                    this.loadTitle().then((res) => {
                        // console.log(res)
                        // console.log(this.initValue)
                        this.selectList = [
                            {
                                label: '没有正确加载数据',
                                value: 0
                            }
                        ]
                        if (this.allSelectData[this.propType]) {
                            this.selectList = [...this.allSelectData[this.propType]]
                        }
                        this.selectAllList = [...this.selectList]
                        console.log(this.initValue);
                        this.selectList.forEach(i => {

                            if(i.value == this.initValue){
                                this.labelData = i.label
                            }
                        })
                        // console.log(this.selectList)
                    })
                }
            }
        },
        created() {

        },
        mounted() {
            this.waitTitle()
            
        }
    }
</script>

<style scoped>
    .input-style{
        width: 90%;
        height: 2rem;
        background-color: #F8FAFB;
        border: none;
        border-radius: 1rem;
        padding: 0  .8125rem;
        font-size: .875rem;
    }
    .selectListStyle{
        position: relative;
        top: 0rem;
    }
    .selectStyle{
        position: relative;
        top: 0rem;
    }
    .select-div{
        position: absolute;
        top: 2.1875rem;
        left: -1.25rem;
        width: 120%;
        background-color: #fff;
        z-index: 99;
        border-radius: 0.3125rem;
        border: solid 0.0625rem #eee;
    }
    .input_li{     
        width: 86%;
        height: 1.9375rem;
        font-size: 0.875rem;
        background-color: #F8FAFB;
        padding-left: 0.625rem;
        line-height: 2.0625rem;
        border-radius: 0.3125rem;
        margin: 0.625rem auto;
    }
</style>